<template>
    <div>Прочие доходы и расходы из прибыли</div>
</template>

<script>
export default  {
    name: 'profit-income-expenses-view'
}
</script>